import type { Space } from "@/react/types";
import { CourseSpaceRoutes } from "@circle-react/components/Spaces/CourseSpace/Routes";
import { useIsLockedSpace } from "@circle-react/hooks/useIsLockedSpace";
import { SpaceLockScreen } from "../Show/SpaceLockScreen";

interface CourseContentProps {
  space: Space;
}
export const CourseContent = ({ space }: CourseContentProps) => {
  const isLockedSpace = useIsLockedSpace();

  if (isLockedSpace) {
    return <SpaceLockScreen space={space} />;
  }

  return <CourseSpaceRoutes />;
};
